module.exports = __webpack_public_path__ + "static/img/7-02.579ef24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7-02.png
// module id = 181
// module chunks = 1